// extracted by css-extract-rspack-plugin
export default {"EmailLink":"ROehV"};